<template>
  <section>
    <m-table-list
      ref="tableList"
      :fetch-list-func="fetchListFunc"
      :search-form.sync="filters"
    >
      <template v-slot:search-items>
        <m-search-panel
          @searchBoxChange="handleSearch"
          isShowOpenButton
          @keyup.enter.native="handleSearch()"
        >
          <div slot="title">
            数据筛选
            <el-input
              style="padding-left: 20px; width: 310px !important"
              maxlength="50"
              placeholder="输入问题标题/问题描述搜索"
              clearable
              size="medium"
              v-model.trim="filters.keyword"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input>
          </div>
          <div class="filters">
            <div class="query-item-all">
              <div class="filter-item">
                <div class="demonstration">工单编号</div>
                <el-input
                  v-model="filters.wkOrderId"
                  placeholder="编号"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  style="min-width: 90px"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单状态</div>
                <el-select
                  v-model="filters.workOrderStatus"
                  placeholder="全部"
                  style="min-width: 90px"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.code"
                    :value="item.code"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">审批状态</div>
                <el-select v-model="filters.handleResult" placeholder="全部">
                  <el-option
                    v-for="(item, index) in handleResultOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">提交时间</div>
                <div class="block">
                  <el-date-picker
                    style="z-index: 0"
                    v-model="timeQuantum"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="handleTimeChange"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="filter-item">
                <div class="demonstration">提交人</div>
                <el-input
                  v-model="filters.authorName"
                  style="min-width: 90px"
                  placeholder="输入"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">承接人</div>
                <el-input
                  v-model="filters.acceptorName"
                  style="min-width: 90px"
                  placeholder="输入"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单分类</div>
                <el-select
                  @change="workCutChange($event)"
                  v-model="filters.parentQaTypeId"
                  placeholder="全部"
                  style="min-width: 90px"
                >
                  <el-option
                    v-for="item in workCutList"
                    :key="item.parentTypeId"
                    :value="item.parentTypeId"
                    :label="item.parentQaTypeName"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单类型</div>
                <el-select
                  :disabled="workTypeFlag"
                  style="width: 202px; min-width: 90px"
                  v-model="filters.qaTypeId"
                  placeholder="全部"
                >
                  <el-option
                    v-for="item in workTypeList"
                    :key="item.qaTypeId"
                    :value="item.qaTypeId"
                    :label="item.qaTypeName"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">优先级</div>
                <el-select v-model="filters.priority" placeholder="优先级">
                  <el-option
                    v-for="(label, value) in priorityEnum"
                    :key="label"
                    :value="value"
                    :label="label"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">标签</div>
                <el-cascader
                  v-model="labelSelected"
                  :options="tagsOptions"
                  :props="{
                    label: 'label',
                    value: 'id',
                    children: 'childList',
                    multiple: true,
                  }"
                  @change="labelChange"
                  clearable
                  collapse-tags
                  filterable
                  :show-all-levels="false"
                ></el-cascader>
              </div>
              <div class="filter-item">
                <div class="demonstration">客户</div>
                <el-input v-model="filters.customer"></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">相关机构</div>
                <el-input v-model.trim="filters.companyInfo"></el-input>
              </div>
              <div class="filter-item buttons">
                <el-button type="primary" size="small" @click="handleSearch"
                  >查询</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  plain
                  @click="handleClearSearchForm"
                  >重置</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  plain
                  @click="exportData"
                  >导出</el-button
                >
              </div>
            </div>
          </div>
        </m-search-panel>
      </template>
      <template v-slot:page-title>
        <div class="page-tabe-title">
          <div class="right">
            <span class="line"></span>
            <div>数据列表</div>
          </div>
        </div>
      </template>
      <template v-slot:table-columns>
        <el-table-column
          label="工单编号"
          show-overflow-tooltip
          width="209px"
          prop="wkOrderId"
        >
        </el-table-column>
        <el-table-column
          label="问题标题"
          prop="wkOrderTopic"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="提交人"
          prop="authorName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="承接人"
          prop="acceptorName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="工单类型"
          prop="qaTypeName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="提交时间"
          prop="submitTime"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="受理时间"
          prop="acceptTime"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.acceptTime || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="审批状态"
          prop="handleResult"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.handleResult"
              size="mini"
              :type="handleResultEnum[scope.row.handleResult].type"
            >
              {{ handleResultEnum[scope.row.handleResult].label }}
            </el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="工单状态" prop="status" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag size="mini" :type="statusEnum[scope.row.status].type">
              {{ statusEnum[scope.row.status].label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="优先级"
          prop="priority"
          :formatter="(row) => priorityEnum[row.priority]"
        ></el-table-column>
        <el-table-column label="标签" prop="labelName" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.labelName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="相关机构"
          prop="companyInfo"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.companyInfo || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="{ row }">
            <el-button
              @click="
                $router.push({
                  name: 'work.relationship.detail',
                  query: { id: row.id, wkOrderId: row.wkOrderId },
                })
              "
              type="text"
              >查看
            </el-button>
            <el-button
              type="text"
              v-if="row.customerList != null && row.customerList.length > 0"
              @click.native="showCoustomModel(row)"
              >客户信息
            </el-button>
          </template>
        </el-table-column>
      </template>
    </m-table-list>
    <coustomer-model
      :visible="coustomVisible"
      :customerList="customerList"
      @close="coustomVisible = false"
    ></coustomer-model>
  </section>
</template>
<script>
import tableList from "components/tableList";
import api from "plus/api";
import coustomerModel from "components/coustomerModel";
import {
  statusEnum,
  statusOptions,
  priorityEnum,
  handleResultEnum,
  handleResultOptions,
} from "@/components/data.js";

export default {
  name: "work.acceptRecord.index",
  data() {
    return {
      workTypeFlag: true,
      timeQuantum: [],
      workTypeList: [],
      workCutList: [],
      filters: {
        acceptorName: "",
        parentQaTypeId: "",
        workOrderStatus: null,
        qaTypeId: "",
        authorName: "",
        wkOrderId: "",
        createBeginTime: "",
        createEndTime: "",
        priority: "",
        label: [],
        customer: "",
        companyInfo: "",
        keyword: "",
      },
      labelSelected: [],
      tagsOptions: [],
      customerList: [],
      coustomVisible: false,
      statusEnum,
      statusOptions,
      priorityEnum,
      handleResultEnum,
      handleResultOptions,
    };
  },
  activated() {
    this.getDropDownList();
  },
  deactivated() {},
  components: {
    "m-table-list": tableList,
    "coustomer-model": coustomerModel,
  },
  created() {},
  computed: {},
  methods: {
    fetchListFunc: api.work.myRelationOrder,
    showCoustomModel(row) {
      this.coustomVisible = true;
      this.customerList = row.customerList;
    },
    labelChange(v) {
      if (!v) {
        this.filters.label = [];
      } else {
        const groupId = [...new Set(v.map((item) => item[0]))];
        const childrenId = v.map((item) => item[1]);
        const result = groupId.map((item) => {
          return {
            labelGroupId: item,
            labelNames: this.tagsOptions
              .filter((parent) => parent.id === item)[0]
              .childList.filter((item) => childrenId.includes(item.id))
              .map((item) => item.label),
          };
        });
        this.filters.label = result;
      }
    },
    handleTimeChange(val) {
      if (val) {
        const startTime = val[0];
        const endTime = val[1] + 60 * 60 * 1000 * 24 - 1;
        this.filters.createBeginTime = new Date(startTime);
        this.filters.createEndTime = new Date(endTime);
      } else {
        this.filters.createBeginTime = "";
        this.filters.createEndTime = "";
        this.timeQuantum = [];
      }
    },
    //分类改变引起类型改变
    workCutChange(e) {
      let filters = {
        id: e,
      };
      this.filters.qaTypeId = "";
      api.dropDownList.getWorkType(filters).then((res) => {
        this.workTypeList = res.data.data;
        this.workTypeFlag = false;
        // ;
        // ;
      });
    },
    getDropDownList() {
      // api.getDropDownList.getWorkType
      api.dropDownList.getWorkCut().then((res) => {
        //工单分类下拉
        this.workCutList = res.data.data;
      });
      api.manage.getTagTree().then((res) => {
        this.tagsOptions = res.data.data;
      });
    },
    handleSearch() {
      this.$refs.tableList.handleSearch();
    },
    handleClearSearchForm() {
      this.workTypeFlag = true;
      this.$refs.tableList.resetSearchForm();
      this.timeQuantum = [];
      this.labelSelected = [];
    },
    updateStatus(item) {
      this.$confirm("是否启用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api.manage
          .setMenuStatus({ menuIds: [item.id], status: item.status })
          .then(() => {
            this.$message.success("删除成功");
            this.$refs.tableList.getMainData();
          });
      });
    },
    async exportData(){
      const res = await api.work.exportMyRelationOrder(this.filters);
      // console.log("导出数据",res); // test
      const blob = new Blob([res.data]);
      const fileName = "我关注的工单数据.xlsx";
      const linkNode = document.createElement("a");
      linkNode.download = fileName;
      linkNode.style.display = "none";
      linkNode.href = URL.createObjectURL(blob);
      document.body.appendChild(linkNode);
      linkNode.click();
      URL.revokeObjectURL(linkNode.href);
      document.body.removeChild(linkNode);
    }
  },
};
</script>
<style lang="less" scoped>
.wap {
  .page {
    color: red;
  }
}
</style>
